export enum StoreId {
  Access = 'access',
  Auth = 'auth',
  Autocorrect = 'autocorrect',
  AssignmentPending = 'assignment-pending',
  BankDetails = 'bank-details',
  Cache = 'cache',
  ControlPending = 'control-pending',
  CounterpartyAddresses = 'counterparty-addresses',
  CounterpartyComments = 'counterparty-comments',
  CounterpartyContacts = 'counterparty-contacts',
  CounterpartyDocs = 'counterparty-docs',
  CounterpartyList = 'counterparty-list',
  CounterpartyRow = 'counterparty-row',
  CounterpartyMaster = 'counterparty-master',
  DocClients = 'doc-clients',
  DocComments = 'doc-comments',
  DocGantt = 'doc-gantt',
  DocLinks = 'doc-links',
  DocSignatures = 'doc-signatures',
  DocAccess = 'doc-access',
  DocAudit = 'doc-audit',
  DocViews = 'doc-views',
  DocumentList = 'document-list',
  DocumentRow = 'document-row',
  DocumentColor = 'document-color',
  DocumentEdit = 'document-edit',
  FileEditor = 'file-editor',
  FileRename = 'file-rename',
  MasterForm = 'master-form',
  DocumentMaster = 'document-master',
  NotificationTimer = 'notification-timer',
  Preview = 'preview',
  PreviewFiles = 'preview-files',
  PreviewFilesUi = 'preview-files-ui',
  Roles = 'roles',
  Sign = 'core.sign',
  SyncSystem = 'sync-system',
  Menu = 'document.menu',
  System = 'system',
  UserList = 'user-list',
  Viewer = 'viewer',
  User = 'user',
  Version = 'version',
}
